import React, { ReactNode } from 'react';
import { Anchor, List, Text } from '@mantine/core';
import cssApp from '../../../app.module.css';

export type Markup = Record<string, ReactNode | ((children: ReactNode) => ReactNode)>;

export function createLink(href: string): (children: ReactNode) => ReactNode {
  return (children: ReactNode): ReactNode => (
    <Anchor href={href} target="_blank" rel="noopener noreferrer">
      {children}
    </Anchor>
  );
}

export function getLinks(links: Record<string, string>): Markup {
  return Object.fromEntries(Object.entries(links).map(([key, href]) => [key, createLink(href)]));
}

const listStyles = {
  root: {
    listStylePosition: 'outside' as const,
  },
};

const listItemStyles = {
  itemWrapper: {
    display: 'block',
    maxWidth: '100%',
    minWidth: 0,
    overflowWrap: 'break-word' as const,
    wordBreak: 'break-word' as const,
  },
};

export const markup: Markup = {
  br: <br />,
  b: children => <b>{children}</b>,
  i: children => <i>{children}</i>,
  p: children => <p>{children}</p>,
  u: children => <u>{children}</u>,
  ol: children => (
    <List type="ordered" withPadding spacing="xs" styles={listStyles} className={cssApp.textColor}>
      {children}
    </List>
  ),
  ul: children => (
    <List withPadding spacing="xs" styles={listStyles} className={cssApp.textColor}>
      {children}
    </List>
  ),
  li: children => (
    <List.Item styles={listItemStyles}>
      <Text className={cssApp.textColor}>{children}</Text>
    </List.Item>
  ),
  'li-sm': children => (
    <List.Item styles={listItemStyles}>
      <Text size="sm" className={cssApp.textColor}>
        {children}
      </Text>
    </List.Item>
  ),
  t: children => <Text className={cssApp.textColor}>{children}</Text>,
  't-lg': children => (
    <Text size="lg" className={cssApp.textColor}>
      {children}
    </Text>
  ),
  't-sm': children => (
    <Text size="sm" className={cssApp.textColor}>
      {children}
    </Text>
  ),
};
